import styled from 'styled-components';


export const Component = styled.div`
  justify-self: center;  
`;